import script from "./HomeTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeTabs.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__